// extracted by mini-css-extract-plugin
export default {"title":"adminPanel_title__uYhGb"};